'use client';

import { useEffect, useState } from 'react';
import BannerAd from './BannerAd';
import { useAds } from './AdContext';
import { ADSENSE_SLOT_SIDE, ADSENSE_SLOT_BOTTOM } from './adsenseConfig';

export default function AdLayout({
  children,
  showSideAds = true,
  showLeftSideAd = false,
  showBottomAd = true,
  sideAdSlot,
  bottomAdSlot,
}) {
  const [isMobile, setIsMobile] = useState(false);
  const { shouldShowAds } = useAds();
  const renderRight = showSideAds && !isMobile && shouldShowAds;
  const renderLeft = showLeftSideAd && !isMobile && shouldShowAds;
  const hasAnySideRail = renderLeft || renderRight;

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1200);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Determine grid layout based on which side rails are shown
  // If no ads, use smaller side margins (not huge gaps)
  const gridClass = hasAnySideRail
    ? renderLeft && renderRight
      ? 'mx-auto grid max-w-[1800px] gap-4 px-4 xl:grid-cols-[180px_minmax(0,1fr)_180px]'
      : renderLeft
        ? 'mx-auto grid max-w-[1800px] gap-4 px-4 xl:grid-cols-[180px_minmax(0,1fr)]'
        : 'mx-auto grid max-w-[1800px] gap-4 px-4 xl:grid-cols-[minmax(0,1fr)_180px]'
    : 'w-full px-2 md:px-4 xl:px-16';

  return (
    <div className="relative min-h-screen">
      {/* Main Content with optional side rails */}
      <div
        className={isMobile ? 'pb-[28px]' : 'pb-[110px]'}
        style={{
          paddingBottom: showBottomAd ? undefined : '0',
        }}
      >
        <div className={gridClass}>
          {renderLeft && (
            <aside className="relative hidden xl:block">
              <div className="sticky top-20">
                <BannerAd
                  position="side"
                  slot={sideAdSlot || ADSENSE_SLOT_SIDE}
                  showUpgradeMessage={true}
                />
              </div>
            </aside>
          )}

          <div className="min-w-0">{children}</div>

          {renderRight && (
            <aside className="relative hidden xl:block">
              <div className="sticky top-20">
                <BannerAd
                  position="side"
                  slot={sideAdSlot || ADSENSE_SLOT_SIDE}
                  showUpgradeMessage={true}
                />
              </div>
            </aside>
          )}
        </div>
      </div>
      {/* Bottom Ad - full width, height clamps to the viewport on mobile */}
      {showBottomAd && shouldShowAds && (
        <div
          id="apect-bottom-ad-frame"
          className="fixed bottom-0 left-0 right-0 z-[120] flex w-full justify-center border-t border-border bg-background"
        >
          <BannerAd
            position="bottom"
            slot={bottomAdSlot || ADSENSE_SLOT_BOTTOM}
          />
        </div>
      )}
    </div>
  );
}

